export const PAGE_SIZE = 12;
export const HOVER_PLAY_DELAY = 100;
export const CAROUSEL_DELAY = 4000;
